<template>
  <div class="wrapper--breadcrumb">
    <el-container class="app--container-breadcrumb">
      <el-main class="app--breadcrumb">
        <LadBreadcrumbItems />

        <span
          v-if="hasWishlist"
          class="breadcrumb--wishlist"
          @click="toggleWishlist"
        >
          <i class="fa-heart" :class="[isFavorite ? 'fas' : 'far']" />
        </span>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LadBreadcrumb',
  components: {
    LadBreadcrumbItems: () =>
      import(
        /* webpackChunkName: "lad-breadcrumb-items" */ './components/items'
      ),
  },
  props: {
    uuid: { type: String, default: '' },
    isFavorite: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      base: 'general.breadcrumb',
      inprogress: false,
    }
  },
  computed: {
    ...mapGetters(['currentUserAuth']),
    hasWishlist() {
      return this.uuid !== ''
    },
  },
  watch: {
    isAuth: {
      handler(newValue) {
        if (newValue && this.inprogress) {
          this.toggleWishlist()
        }
      },
    },
  },
  mounted() {
    console.log('breadcrumb component mounted')
  },
  methods: {
    async toggleWishlist() {
      if (this.isAuth) {
        const { status, data } = await this.$axios.get(
          `/api/v1.5/users/wishlist/${this.uuid}/toggle`
        )

        if (status === 'success') {
          this.inprogress = false
          this.$emit('toggle')

          this.$notify({
            title: this.$t(`${this.base}.favorite.title`),
            message: this.$t(`${this.base}.favorite.${data.action}`),
            position: 'bottom-right',
            type: 'success',
          })
        }
      } else {
        this.inprogress = true
        this.$store.dispatch('modals/toggle', 'auth')
      }
    },
  },
}
</script>

<style lang="scss">
.app--container-breadcrumb {
  .app--breadcrumb {
    padding: 10px 20px;
    height: 45px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;

    .breadcrumb--wishlist {
      min-width: 40px;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
